import { render } from "./ServerModules.vue?vue&type=template&id=5413f049&ts=true"
import script from "./ServerModules.vue?vue&type=script&lang=ts"
export * from "./ServerModules.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__